import { StyledTypography } from "./styled";
import { ITypographyProps } from "./types";

const Typography = ({children, color = 'primary', ...props}: ITypographyProps)=>(
    <StyledTypography {...props} color={color}>
        {children}
    </StyledTypography>
)

export {Typography}